import script from "./ByPopularity.vue?vue&type=script&setup=true&lang=js"
export * from "./ByPopularity.vue?vue&type=script&setup=true&lang=js"

import "./ByPopularity.vue?vue&type=style&index=0&id=2ca7e58d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ca7e58d"]])

export default __exports__